import React, { useState, useEffect } from 'react';

import { DropdownButton, Dropdown, Spinner, Row, Col } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import StripePayment from './Stripes'

export default function ChoosePayment({ paymentsList, clientSecret, loadingCB, successCB, failCB }) {
    const [choosedCard, setChoosedCard] = useState(null);

    function setCC({ target }) {
        const { value } = target;
        setChoosedCard(value);
    }

    let selectedCard = paymentsList.find(a => a.paymentMethod === choosedCard);
    return (
        <Row>
            <Tabs
                defaultActiveKey="scc"
                className="mb-3"
                fill
            >
                <Tab eventKey="scc" title="Saved Cards">
                    <Dropdown>
                        <Dropdown.Toggle style={{ width: '100%' }} variant="success" className="DropdownText">
                            Pay with a saved Credit Card
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="DropdownMenu">

                            {
                                paymentsList && paymentsList.map(item =>
                                    <Dropdown.Item key={item.id} as="button" onClick={(e) => setCC(e)} value={item.paymentMethod} >{item.name}</Dropdown.Item>
                                )
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                    {
                        selectedCard &&
                        <div class="PaymentInfoArea">
                            <b>CreditCard Selected: {selectedCard.name} </b>
                            <StripePayment paymentMethod={choosedCard} clientSecret={clientSecret} loadingCB={loadingCB} successCB={successCB} failCB={failCB}/>
                        </div>
                    }

                </Tab>
                <Tab eventKey="cc" title="Credit card">
                    <StripePayment clientSecret={clientSecret} loadingCB={loadingCB} successCB={successCB} failCB={failCB} />
                </Tab>
            </Tabs>

        </Row>
    )
}
